import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';
import type { IdentifiersListTuner } from '../IdentifiersListTuner';
import { injectable } from 'inversify';
import { IdentifiersListTuneCommand } from './IdentifiersListTune.command';
import type { ITuneCommandFactory } from './interfaces';

@injectable()
export class IdentifierTuneCommandsFactory implements ITuneCommandFactory<ICommand, IdentifiersListTuner, string> {
  public createCommand(tuner: IdentifiersListTuner, descriptor: string, val: string): ICommand {
    return new IdentifiersListTuneCommand(tuner, descriptor, val);
  }
}
